const nAgt = typeof navigator !== "undefined" ? navigator.userAgent : "";
const nVer = typeof navigator !== "undefined" ? navigator.appVersion : "";

const getBrowserName = () => {
  const browsers = {
    Edge: /Edg\/([\d\.]+)/,
    Firefox: /(?:Firefox|FxiOS)\/([\d\.]+)/,
    Safari: /Version\/([\d\.]+).*Safari/,
    Chrome: /(?:Chrome|CrMo|CriOS)\/([\d\.]+)/,
    IE: /MSIE ([\d\.]+).*Trident/,
    Opera: /(?:Opera|OPR)\/([\d\.]+)/,
  };

  for (const browserName in browsers) {
    if (browsers[browserName].test(nAgt)) {
      return browserName;
    }
  }
  return "Unknown";
};

const getDeviceType = () => {
  const isMobileUA = /Mobi|Android/i.test(nAgt);
  const isTabletUA = /Tablet|iPad/i.test(nAgt);
  const isDesktopUA = /Windows NT|Macintosh/i.test(nAgt);
  const screenWidth = window.screen.width;
  const isSmallScreen = screenWidth <= 768;

  if (isDesktopUA && !isSmallScreen) return "Desktop";
  if (isTabletUA) return "Tablet";
  if (isMobileUA || isSmallScreen) return "Mobile";
  return "Unknown";
};

const getOsInfo = () => {
  const clientStrings = [
    { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
    { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
    { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
    { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
    { s: "Android", r: /Android/ },
    { s: "iOS", r: /(iPhone|iPad|iPod)/ },
    { s: "Mac OS X", r: /Mac OS X/ },
    { s: "Linux", r: /(Linux|X11)/ },
  ];

  let os = "unknown";
  for (const cs of clientStrings) {
    if (cs.r.test(nAgt)) {
      os = cs.s;
      break;
    }
  }

  let osVersion = "Unknown";
  if (/Windows/.test(os)) {
    osVersion = /Windows (.*)/.exec(os)?.[1] || "Unknown";
  } else if (os === "Mac OS X") {
    osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)?.[1] || "Unknown";
  } else if (os === "Android") {
    osVersion = /Android ([\.\_\d]+)/.exec(nAgt)?.[1] || "Unknown";
  } else if (os === "iOS") {
    const match = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
    if (match) {
      osVersion = `${match[1]}.${match[2]}.${match[3] || 0}`;
    }
  }

  return { os, osVersion };
};

const getDeviceManufacturer = () => {
  if (/iPhone|iPad|iPod|Macintosh|Mac OS/i.test(nAgt)) return "Apple";
  if (/Android/i.test(nAgt)) {
    const match = nAgt.match(/Android.*?;\s*([^;)]+)\s*Build/i);
    return match?.[1]?.trim() || "Android";
  }
  if (/Windows/i.test(nAgt)) return "Microsoft";
  return "";
};

/** Device fields for login / firebase_login_confirm API payloads */
export const getDeviceLoginPayload = () => {
  const { osVersion } = getOsInfo();
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;

  return {
    device_type: getDeviceType(),
    device_os_version: osVersion,
    device_name: getBrowserName(),
    device_width: screenWidth,
    device_height: screenHeight,
    device_manufacturer: getDeviceManufacturer(),
    user_agent: nAgt,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  };
};
